// This file is auto-generated. Do not edit manually.

import { z } from "zod";
import { UuidSchema } from "./utilitySchemas";

const isValidPhoneNumber = (value: string) => {
  const normalizedValue = value.replace(/[()\s-]/g, "");
  return /^\+[1-9]\d{7,14}$/.test(normalizedValue);
};

export const StakeHolderType = z.enum(["invoiceRecipient", "customer", "propertyOwner", "guestUser"]);
export type StakeHolderTypeEnum = z.infer<typeof StakeHolderType>;

export const OwnerShipType = z.enum(["soleOwner", "notSoleOwner", "notOwner"]);
export type OwnerShipTypeEnum = z.infer<typeof OwnerShipType>;

export const RequestStakeholderSchema = z.object({
  id: z.number().int(),
  title: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  companyName: z.string(),
  streetName: z.string(),
  streetNumber: z.string(),
  postalCode: z.string(),
  city: z.string(),
  country: z.string(),
  phoneNumber: z.string(),
  email: z.string().email(),
  type: StakeHolderType,
  ownershipType: OwnerShipType.optional(),
  requestId: UuidSchema,
  entryType: z.string().optional(),
});
export type RequestStakeholder = z.infer<typeof RequestStakeholderSchema>;

export const CreateStakeholderSchema = z.object({
    title: z.string().min(1, "Title is required"),
    firstName: z.string().min(1, "First name is required"),
    lastName: z.string().min(1, "Last name is required"),
    companyName: z.string().nullish(),
    streetName: z.string().min(1, "Street name is required"),
    streetNumber: z.string().min(1, "Street number is required"),
    postalCode: z.string().min(1, "Postal code is required"),
    city: z.string().min(1, "City is required"),
    country: z.string().min(1, "Country is required"),
    phoneNumber: z
      .string()
      .min(1, "Phone number is required")
      .refine(isValidPhoneNumber, { message: "Invalid phone number" }),
    email: z.string().email("Invalid email address"),
    type: StakeHolderType,
    ownershipType: OwnerShipType.optional(),
    entryType: z.string().optional(),
});
export type CreateStakeholder = z.infer<typeof CreateStakeholderSchema>;

export const UpdateStakeholderSchema = RequestStakeholderSchema.partial()
  .omit({
    requestId: true,
  })
  .extend({ id: z.number().int() });
export type UpdateStakeholder = z.infer<typeof UpdateStakeholderSchema>;
